import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Normalises FastAPI/Pydantic error responses so `err.response.data.detail`
// is always a string.  Without this, 422 responses carry an array of
// `{type, loc, msg, input, ctx}` dicts and any component that renders
// `{err.response.data.detail}` directly throws "Objects are not valid as
// a React child".
function installErrorNormalizer(instance) {
  instance.interceptors.response.use(
    (r) => r,
    (err) => {
      const d = err?.response?.data?.detail;
      if (Array.isArray(d)) {
        err.response.data.detail = d
          .map((x) => `${(x.loc || []).slice(1).join(".") || "field"}: ${x.msg}`)
          .join(" · ");
      } else if (d && typeof d === "object") {
        err.response.data.detail = JSON.stringify(d);
      }
      return Promise.reject(err);
    }
  );
}

// Install on the default axios instance…
installErrorNormalizer(axios);

// …and on every future `axios.create(...)` call (SuperAdmin, Kiosk, print
// pages all use bespoke instances).  Interceptors on the default axios
// object do NOT propagate to instances, hence this monkey-patch.
const _origCreate = axios.create.bind(axios);
axios.create = (config) => {
  const inst = _origCreate(config);
  installErrorNormalizer(inst);
  return inst;
};

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("dhoms_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default api;

export const fmtINR = (n) =>
  "₹" + (Number(n || 0)).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export const fmtDate = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDT = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};
